package com.ricky.realtimeledger.utils

import androidx.compose.runtime.*
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import kotlinx.browser.window
import org.w3c.dom.events.Event

// 1. Define the Global Local Variable
val LocalBreakpoint = staticCompositionLocalOf { Breakpoint.ZERO }

// 2. A custom Composable hook that listens to window resizes
@Composable
fun rememberBreakpoint(): State<Breakpoint> {
    val breakpoint = remember { mutableStateOf(calculateBreakpoint()) }

    LaunchedEffect(Unit) {
        val listener: (Event) -> Unit = {
            breakpoint.value = calculateBreakpoint()
        }
        // Listen to the browser's resize event
        window.addEventListener("resize", listener)
    }

    return breakpoint
}

// 3. Helper to map pixel width to Kobweb Breakpoints
private fun calculateBreakpoint(): Breakpoint {
    val width = window.innerWidth
    return when {
        width >= 1440 -> Breakpoint.XXL
        width >= 1280 -> Breakpoint.XL
        width >= 1024 -> Breakpoint.LG
        width >= 768 -> Breakpoint.MD
        width >= 640 -> Breakpoint.SM
        else -> Breakpoint.ZERO
    }
}